import React, { Component } from "react";
import axios from "axios";

import { forEach } from "lodash";
import { Anchor } from "grommet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Moment from "react-moment";

import WebinarComponent from "./LearnerAssesment/WebinarComponent";
import Paper from "@material-ui/core/Paper";
import {
  faArrowAltCircleLeft,
  faTimesCircle,
  faChevronDown,
  faCalendarAlt,
  faClock,
  faPlayCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  Collapse,
  CardBody,
  Card,
  CardHeader,
  Row,
  Col,
  Badge,
} from "reactstrap";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { toast } from "react-toastify";


class Webinar extends Component {
  constructor(props) {
    super(props);
    const weblist = [];
    const webvideolist = [];

    this.toggle = this.toggle.bind(this);
    this.state = {
      weblist,
      webvideolist,
      setmyview: "",
      contentid: "",
      contenttype: "",
      videoid: "",
      collapseBanner: "",
      collapseCycle: "",
      collapseReleaseDate: "",
      collapseLayout: "",
      webinarmenu: true,
      expanded: 0,

    };
  }

  componentDidMount() {
    this.getwebinardetails();
  }

  toggle(e) {
    let event = e.target.dataset.event;
    let key = e.target.dataset.type;
    switch (key) {
      case "collapseBanner": {
        this.setState({
          collapseBanner: event,
          collapseCycle: "",
          collapseReleaseDate: "",
          collapseLayout: "",
        });
        break;
      }
      case "collapseCycle": {
        this.setState({
          collapseCycle: event,
          collapseReleaseDate: "",
          collapseLayout: "",
        });
        break;
      }
      case "collapseReleaseDate": {
        this.setState({
          collapseReleaseDate: event,
          collapseLayout: "",
          collapseCycle: "",
        });
        break;
      }
      case "collapseLayout": {
        this.setState({ collapseLayout: event });
        break;
      }
      default:
        break;
    }
  }

  async getwebinardetails() {
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    axios
      .post("CourseWebinar/webinars", formData)
      .then((res) => {
        // console.log("res.data  == "+ res.data)
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            weblist: res.data.weblist,
            webvideolist: res.data.webvideolist,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }
  handleChange = (panel) => (event, newExpanded) => {
    // setExpanded(newExpanded ? panel : false);
    if (newExpanded) {
      this.setState({
        expanded: panel,
      });
    } else {
      this.setState({
        expanded: false,
      });
    }
  };


  renderWebinar(item) {
    let result = [];

    result.push(
      // <Card style={{ marginBottom: "1rem" }} key={item[0].id}>
      //   <CardHeader
      //     onClick={this.toggle}
      //     data-event={item[0].title}
      //     data-type="collapseCycle"
      //   >
      //     <span> Webinar Date </span>&nbsp; &nbsp;
      //     <FontAwesomeIcon icon={faCalendarAlt} />
      //     <Moment format="DD-MM-YYYY">{item[0].webinar_date}</Moment>
      //     &nbsp; &nbsp;
      //     <FontAwesomeIcon icon={faClock} />
      //     {item[0].duration_in_minutes}
      //     <h4>{item[1].id}</h4>
      //     {item[1] !== "null" ? (
      //       <div>
      //         {item[1].map((sub) => (
      //           <div>
      //             <span style={{ color: "blue" }}>Recording </span> &nbsp;
      //             &nbsp;
      //             <Anchor
      //               onClick={(e) =>
      //                 this.setState({
      //                   setmyview: "video",
      //                   contentid: sub.id,
      //                   videoid: sub.id,
      //                   contenttype: "Webinar",
      //                 })
      //               }
      //             >
      //               <FontAwesomeIcon icon={faPlayCircle} />
      //             </Anchor>
      //           </div>
      //         ))}
      //       </div>
      //     ) : (
      //       " "
      //     )}
      //   </CardHeader>
      //   <Collapse isOpen={this.state.collapseCycle === item.webinar_date}>
      //     <CardBody>{item.duration_in_minutes}</CardBody>
      //   </Collapse>
      // </Card>



      <Typography>
        <div
          aria-controls="panel1a-content"
          id="panel1a-header"
          className="typography-topic webinar-data" >

          Date &nbsp;
          <div className="webinar-date">
            <FontAwesomeIcon icon={faCalendarAlt} color="blue" />&nbsp;
            {item.webinardate}
          </div>
          <div className="webinar-time" >

            <FontAwesomeIcon icon={faClock} color="orange" />  &nbsp;
            {item.time}
          </div>

        </div>
        <div id="style-6" class="desc scrollbartopiccontent">
          <span class="force-overflowtopiccontent">
            <div expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header">



              {item.newRecordinglist !== "null" && item.newRecordinglist.length > 0 ? (
                <>

                  {/* <div  className="webinar-img"> 
             <img src="/assets/images/icons/vmms_video.svg"  alt="vmms_video" />&nbsp; 
             ({item.newRecordinglist.length})
             </div> */}


                  {item.newRecordinglist.map((sub, indexid) => (
                    <div>
                      {sub.flag == 'YES' ? 
                      <a href={sub?.video_link} target="_blank">
                      <CardHeader>
                        <img src="/assets/images/icons/vmms_video.svg" alt="vmms_video" style={{ height: "15px", width: "15px" }} />&nbsp; Recording - {indexid + 1} </CardHeader> 
                        </a>
                        :
                        <Anchor
                          onClick={(e) => {
                            this.setState({
                              setmyview: "video",
                              contentid: sub.recordingid,
                              videoid: sub.recordingid,
                              contenttype: "Webinar",
                            }); window.scrollTo(0, 0);
                          }
                          }
                        >

                          <CardHeader>
                            <img src="/assets/images/icons/vmms_video.svg" alt="vmms_video" style={{ height: "15px", width: "15px" }} />&nbsp; Recording - {indexid + 1} </CardHeader>
                        </Anchor>
                      }
                    </div>
                  ))}


                </>
              ) : (
                " "
              )}

            </div>
          </span>
        </div>
      </Typography>





    );

    return result;
  }

  renderOutline() {
    let result = [];
    forEach(this.state.webvideolist, (item, bannerId) => {
      result.push(
        // <Card
        //   style={{ marginBottom: "1 rem", background: " rgba(29,124,248,.05)" }}
        //   key={item[0].title}
        // >
        //   <CardHeader
        //     onClick={this.toggle}
        //     data-event={item[0].title}
        //     data-type="collapseBanner"
        //   >
        //     <p className="card-header-sub">
        //       {item[0].title} &nbsp; - &nbsp; &nbsp;
        //       <Moment format="DD-MM-YYYY">{item[0].webinar_date}</Moment>
        //       <Anchor
        //         class="click-layer"
        //         onClick={this.toggle}
        //         data-event={item[0].title}
        //       ></Anchor>
        //     </p>
        //   </CardHeader>
        //   <Collapse isOpen={this.state.collapseBanner === item[0].title}>
        //     <CardBody>{this.renderWebinar(item)}</CardBody>
        //   </Collapse>
        // </Card>
        <Accordion square
          expanded={this.state.expanded === bannerId}
          onChange={this.handleChange(bannerId)}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>{item.title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              {this.renderWebinar(item)}
            </Typography>
          </AccordionDetails>
        </Accordion>
      );
    });
    return result;
  }
  render() {
    return (
      <div>
        
        <Card className="bg-color-tab">
          {this.state.weblist.length === 0 ? (
            <>
              <center>
                <br /> <br />
                <img
                  dir="images"
                  src="/assets/images/icons/no-announcement.svg"
                  alt=""
                  width="300"
                  height="150"
                  className="img-thumbnail"
                />
                <br /> <br />
                <h6>" No webinars!"</h6>
              </center>
            </>
          ) : (
            <>


              {this.state.webinarmenu ? (
                <Row>
                  <Col lg={8} className="container pt-2">
                  <b style={{color:'red'}}><center>To watch this video please login to your email registered with eduplusnow, in the current browser window</center></b>
                    <br />
                    {(() => {
                      switch (this.state.setmyview) {
                        case "video":
                          return (
                            <WebinarComponent
                              contentType={this.state.contenttype}
                              contentId={this.state.contentid}
                              videoid={this.state.videoid}
                            />
                          );

                        default:
                          return "";
                      }
                    })()}
                  </Col>
                  <Col lg={4} className="bg-acc-white accordian">

                    <Paper className="p132-2">
                      Webinar
                      <FontAwesomeIcon
                        className="cross-icon"
                        icon={faTimesCircle}
                        onClick={() =>
                          this.setState({
                            webinarmenu: !this.state.webinarmenu,
                          })
                        }
                      />
                    </Paper>

                    {/* <Badge
                  className="button-course-content"
                  color="light"
                  onClick={() =>
                    this.setState({ webinarmenu: !this.state.webinarmenu })
                  }
                >
                  <FontAwesomeIcon icon={faTimesCircle} />
                </Badge> */}


                    <div id="style-6" class="mr-te desc scrollbarcontent">
                      <span class="force-overflowcontent">
                        {this.renderOutline()}
                      </span>
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col lg={12}>
                    <Badge
                      className="button-course-content-right"
                      color="light"
                      onClick={() =>
                        this.setState({ webinarmenu: !this.state.webinarmenu })
                      }
                    >
                      <FontAwesomeIcon className="course-content-icon" icon={faArrowAltCircleLeft} />
                      <span className="course-content">
                        {" "}
                        Webinar
                      </span>
                    </Badge>{" "}
                    &nbsp; &nbsp; &nbsp; &nbsp;
                  </Col>
                  <Col lg={12}>
                    <div className="container">
                      <br />
                      {(() => {
                        switch (this.state.setmyview) {
                          case "video":
                            return (
                              <WebinarComponent
                                contentType={this.state.contenttype}
                                contentId={this.state.contentid}
                                videoid={this.state.videoid}
                              />
                            );

                          default:
                            return "";
                        }
                      })()}
                    </div>
                  </Col>
                </Row>
              )}
            </>
          )}
        </Card>
      </div>
    );
  }
}

export default Webinar;
